// extracted by mini-css-extract-plugin
module.exports = {"navigation":"NavigationDesktop_navigation__F3hTe","item":"NavigationDesktop_item__xsPOU"};